import Vue from 'vue'
import Parse from 'parse'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import PubNubVue from 'pubnub-vue'
import Chat from 'vue-beautiful-chat'
import VueTour from 'vue-tour'
import MessageDialog from '@/components/common/MessageDialog'
import MultiSelect from '@/components/common/MultiSelect'
import DatetimePicker from '@/components/common/DatetimePicker'
import GoogleAutocomplete from '@/components/common/GoogleAutocomplete'
import router from './router'
import store from './store'
import VueSignature from 'vue-signature-pad'
import axios from 'axios'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

/* import * as VueGoogleMaps from 'vue2-google-maps' */
// comment
import './assets/scss/style.scss'

Vue.use(Toast)
const HelloJs = require('hellojs/dist/hello.all.min.js')
const VueHello = require('vue-hellojs')
Vue.use(VueSignature)

// /**Initialize parse server SDK */
Parse.initialize('71237DFB8FA1D83A3363EB45CF0B4AC7BD44E1EA')
Parse.masterKey = 'EE1AE6E26B3D99A91968F9D0E2D544E2887A1FF7'
Parse.serverURL = 'https://thedriverx.com/parse'
// Parse.serverURL = 'https://stage.thedriverx.appscorridor.com/parse'
// Parse.serverURL = 'http://localhost:1337/parse'
// axios.defaults.baseURL = 'http://localhost:1337'
axios.defaults.baseURL = 'https://www.thedriverx.com'
// axios.defaults.baseURL = 'https://stage.thedriverx.appscorridor.com'
// Parse.serverURL = 'https://hostdev.tk/parse'
// Parse.serverURL = 'http://localhost:3000/parse'
store.dispatch('getUser')

Vue.config.productionTip = false

// Try to load and register vuetify-google-autocomplete
let VuetifyGoogleAutocomplete
try {
  // Try different import methods
  VuetifyGoogleAutocomplete = require('vuetify-google-autocomplete')
  if (VuetifyGoogleAutocomplete && VuetifyGoogleAutocomplete.default) {
    VuetifyGoogleAutocomplete = VuetifyGoogleAutocomplete.default
  }

  // Check if it's a valid component
  if (VuetifyGoogleAutocomplete && typeof VuetifyGoogleAutocomplete === 'object') {
    Vue.component('vuetify-google-autocomplete', VuetifyGoogleAutocomplete)

    // Try to use the plugin
    try {
      Vue.use(VuetifyGoogleAutocomplete, {
        apiKey: 'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0',
        version: '3'
      })
      console.log('Successfully registered vuetify-google-autocomplete component')
    } catch (pluginError) {
      console.warn('Plugin registration failed, but component is available:', pluginError)
    }
  } else {
    throw new Error('Invalid component structure')
  }
} catch (error) {
  console.warn('Failed to load vuetify-google-autocomplete:', error)
  console.log('Using fallback component instead')

  // Create a dummy component to prevent errors - using render function instead of template
  Vue.component('vuetify-google-autocomplete', {
    props: ['value', 'apiKey', 'version', 'placeholder', 'types', 'country', 'componentRestrictions'],
    render (h) {
      return h('div', {
        style: { display: 'none' }
      })
    },
    mounted () {
      console.warn('vuetify-google-autocomplete component is not available, please use google-autocomplete instead')
    }
  })
}

// Always register the fallback component
Vue.component('google-autocomplete', GoogleAutocomplete)

Vue.component('MessageDialog', MessageDialog)
Vue.component('multi-select', MultiSelect)
Vue.component('datetime-picker', DatetimePicker)

/* Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB24tCL14XhXd19PcnlF7Or2m4jhjm_Fa0',
    libraries: 'places'
  }
}) */

/** Can be initialize only when user is logged in */
if (store.getters.isLogged) {
  Vue.use(PubNubVue, {
    subscribeKey: 'sub-c-9826b49e-ee17-11eb-b0cf-7e76ce3f98e8',
    publishKey: 'pub-c-377c8b4e-d730-4d34-a133-d32cf1589694',
    uuid: store.getters.user.id
  })
}

Vue.use(require('vue-moment'))
Vue.use(VueLodash, { lodash })
Vue.use(Chat)
Vue.use(VueTour)

HelloJs.init(
  {
    google:
      '814141650586-jhpp9qkiti8b73bja90uvjvhb1lmdpcn.apps.googleusercontent.com',
    facebook: '814516556138679'
  },
  {
    scope: 'email',
    redirect_uri: '/'
  }
)

Vue.use(VueHello, HelloJs)

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
